import { Http, Headers, RequestOptions, QueryEncoder, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../../providers/global-service/global-service';
@Injectable()
export class HttpServiceProvider {

  constructor(public http: Http) {
  }
  serializeFormData(options) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key])
    }

    return params.toString();
  }

  text(service: string): Promise<any> {
      let url = GlobalServiceProvider.Url + service;

      let options = new RequestOptions({
          headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': GlobalServiceProvider.Token }),

          method: "GET"
      });
      return new Promise(resolve => {
          this.http.get(url)
              .map(res => res.text())
              .subscribe((data) => {
                  resolve(data);

              }, (error) => { resolve({ success: false, message: "Server error, check your connection, or otherwise something bad has happened", error: true }); });
      });

  }

  call(service: string, data: any): Promise<any> {
    let url = GlobalServiceProvider.ServiceUrl + service;

    let options = new RequestOptions({
      headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': GlobalServiceProvider.Token }),

      method: "POST"
    });
    return new Promise(resolve => {
      this.http.post(url, this.serializeFormData(data), options)
        .map(res => res.json())
        .subscribe((data) => {
          resolve(data);

        }, (error) => { resolve({ success: false, message: "Server error, check your connection, or otherwise something bad has happened", error: true }); });
    });

  }
  callJSON(service: string, data: any): Promise<any> {
    let url = GlobalServiceProvider.ServiceUrl + service;

    let options = new RequestOptions({
      headers: new Headers({ 'Content-Type': 'application/json', 'Authorization': GlobalServiceProvider.Token }),
      method: "POST"
    });
    return new Promise(resolve => {
      this.http.post(url, data, options)
        .map(res => res.json())
        .subscribe((data) => {
          resolve(data);

        }, (error) => { resolve({ success: false, message: "Server error, check your connection, or otherwise something bad has happened" }); });
    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/http-service/http-service.ts